import { Component, Input, Output, OnInit, EventEmitter, HostListener, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() pageSize = 0;
  @Input() isClickable: boolean = true;
  @Input() startingPage = 1;
  @Input() notVisibile = true;
  @Output() currentPageEmitter = new EventEmitter<number>();
  @Output() isClickableChange = new EventEmitter<boolean>();

  currentPage = 1;
  colore: String;
  larghezzaSchermo: number;

  constructor() {
    this.colore = '#0D9A71';
  }

  ngOnInit(): void {
    if (this.pageSize >= this.startingPage && this.startingPage > 0) {
      this.currentPage = this.startingPage;
    }
    this.larghezzaSchermo = window.innerWidth;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pageSize'] && changes['pageSize']?.currentValue) {
      if (this.pageSize >= this.startingPage && this.startingPage > 0) {
        this.currentPage = this.startingPage;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.larghezzaSchermo = window.innerWidth;
  }

  changePage(page: any) {
    if (page > 0 && page <= this.pageSize && this.isClickable) {
      this.currentPage = page;
      this.currentPageEmitter.emit(this.currentPage);
    }
  }
}
